import { AxiosResponse } from 'axios';

import { HttpRequest } from 'SharedDir/backend/axios/http';

import { DEPZDRAV_EXPORT_ENDPOINTS } from 'SharedDir/backend/endpoints/depzdrav-export';
import { StatusResponse } from 'SharedDir/declarations/endpoint';
import { BasePagination, Paginated } from 'SharedDir/declarations/pagination';
import { DepzdravExportHistory } from 'SharedDir/declarations/physical-person';
import fileDownloader from 'SharedDir/utils/file-downloader';

export default class DepzdravExportApiClass {
  protected readonly http: HttpRequest;

  constructor(http: HttpRequest) {
    this.http = http;
  }

  async download() {
    fileDownloader.saveFileFromResponse(
      await this.http(DEPZDRAV_EXPORT_ENDPOINTS.DOWNLOAD)
    );
  }

  /**
   * @deprecated
   */
  async getLast() {
    const { data } = (await this.http(
      DEPZDRAV_EXPORT_ENDPOINTS.GET_LAST
    )) as AxiosResponse<DepzdravExportHistory>;
    return data;
  }

  async generate() {
    const { data } = (await this.http(
      DEPZDRAV_EXPORT_ENDPOINTS.GENERATE
    )) as AxiosResponse<StatusResponse>;
    return data;
  }

  async history(params: Pick<BasePagination, 'page' | 'rowsPerPage'>) {
    const { data } = (await this.http({
      ...DEPZDRAV_EXPORT_ENDPOINTS.HISTORY,
      params,
    })) as AxiosResponse<Paginated<DepzdravExportHistory>>;
    return data;
  }
}
